// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TwitterCard__card___1it8Q{padding:24px}.TwitterCard__header___1FIyX{display:flex;align-items:center;justify-content:space-between;margin-bottom:24px}.TwitterCard__thumbnail___3PnTE{width:32px;height:32px;margin-right:16px;border-radius:16px}.TwitterCard__profile___2hA-7{display:flex;align-items:center;width:100%}.TwitterCard__icon___29wa1{width:22px;height:22px}.TwitterCard__info___1k-r2{color:#807c6c}.TwitterCard__info___1k-r2 strong{color:inherit;font-weight:400;font-size:16px;line-height:24px;color:#564f34}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"card": "TwitterCard__card___1it8Q",
	"header": "TwitterCard__header___1FIyX",
	"thumbnail": "TwitterCard__thumbnail___3PnTE",
	"profile": "TwitterCard__profile___2hA-7",
	"icon": "TwitterCard__icon___29wa1",
	"info": "TwitterCard__info___1k-r2"
};
module.exports = ___CSS_LOADER_EXPORT___;
